import React from 'react';
import moment from 'moment';
import { Container, Image } from 'react-bootstrap';
import getGoogleCalendarUri from 'helper/getGoogleCalendarUri';
import { OutlineButton } from 'components/Button';
import { Link } from 'react-router-dom';
import ExternalLink from 'components/ExternalLink';
import SocialShare from './SocialShare';

import postImg from '../../assets/images/post.jpg';
import styles from './events.module.scss';
import cns from 'classnames';

function SingleDetailedEvent({ data }) {
  if (!data) return null;
  return (
    <div>
      <div className={[styles.bgDust, 'py-5'].join(' ')}>
        <Container>
          <div className={styles.breadCrumbs}>
            <span>
              <Link to="/">Home</Link>{' '}
            </span>{' '}
            <span>
              <Link to="/events">Event</Link>
            </span>{' '}
            <span>
              <Link to={`/event/${data.id}`}>Event Details</Link>
            </span>
          </div>

          <Image
            src={data?.logo?.original?.url || postImg}
            className={cns('w-100', styles.imgevent)}
            fluid
          />
          <div className="textLight my-3">
            <span> {moment(data.start?.utc).format('MMM, DD YYYY')}</span>
            {/* <span className={styles.dot}></span>
            <span>By: Sean</span> */}
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="font-s1 fw800 mb-0">{data?.name?.text || ''}</h5>
            <ExternalLink href={data?.url}>
              <OutlineButton>Register Now</OutlineButton>
            </ExternalLink>
          </div>
          <p className={styles.shareOn}>Share on</p>
          <SocialShare event={data} />

          <table className={styles.postInfo}>
            <tbody>
              <tr>
                <th>Time</th>
                <th>Calendar</th>
              </tr>
              <tr>
                <td>
                  {moment(data.start?.utc).format('DD (dddd) h:mm a')} -
                  {moment(data.end?.utc).format('DD (dddd) h:mm a')}
                </td>
                <td>
                  <ExternalLink
                    href={getGoogleCalendarUri({
                      title: data.name?.text,
                      desc: data.description?.text,
                      end: data.end?.utc,
                      start: data.start?.utc,
                    })}
                  >
                    Google Calendar{' '}
                  </ExternalLink>
                </td>
              </tr>
              <tr>
                <th className="pt-4">ORGANIZER</th>
                <th></th>
              </tr>
              <tr>
                <td>CAP60</td>
                <td> </td>
              </tr>
            </tbody>
          </table>
          <hr className="my-4" />
          <h5 className="font-s1 fw800 mb-3">Event Details</h5>
          <div className={styles.eventDetails}>
            <p>
              {moment(data.start.utc).format('MMMM Do')} -
              {moment(data.end.utc).format('Do, YYYY')}
            </p>

            <ExternalLink href={data.url}>
              Click here to view the {data?.name?.text || ''} Agenda
            </ExternalLink>

            <p>{data.summary}</p>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default SingleDetailedEvent;
